import Swiper from 'swiper';
import DeviceManager, { onPromiseAttrType } from '../utils/device-manager';

export default function initCardsLists() : void {
    const $cardsLists = document.querySelectorAll<HTMLElement>('.js-cards-list');

    $cardsLists.forEach($container => {
        new CardsList($container);
    });
}

class CardsList {
    $container: HTMLElement;
    swiper;
    initialized: boolean;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.initialized = false;

        DeviceManager.addCallback((attr: onPromiseAttrType) => {
            if (!this.initialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.initialized = true;

                this.init();
            } else if (this.initialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.initialized = false;

                this.destroy();
            }
        });
    }

    /**
     * Initialize CardsList
     * 
     * @return {void}
     */
    init() : void {
        this.swiper = new Swiper(this.$container, {
            loop: true,
            spaceBetween: 15,
            threshold: 10,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    /**
     * Destroy CardsList
     * 
     * @return {void}
     */
    destroy() : void {
        this.swiper.destroy();
    }
}
